import { LocalStorage } from 'quasar'

export function SAVE_COUNTRIES(state, [countries]){
    state.countries = countries
}

export function SAVE_COUNTRY(state, [country]){
    state.country = country
    LocalStorage.set('stored_country', country)
}

export function SAVE_COURSES(state, [courses]){
    state.courses = courses
}